import type { AssetWorkflowOptions } from '../../types';
import { addCarrierShipmentLaneConfigurationWorkflow } from './addCarrierShipmentLaneConfigurationWorkflow';
import { editCarrierShipmentLaneConfigurationWorkflow } from './editCarrierShipmentLaneConfigurationWorkflow';
import { generateAssetStatusWorkflow } from '../generateAssetStatusWorkflows';

export const workflows: AssetWorkflowOptions[] = [
  addCarrierShipmentLaneConfigurationWorkflow,
  editCarrierShipmentLaneConfigurationWorkflow,
  ...Object.values(generateAssetStatusWorkflow('laneSortConfigurations')),
];

export default workflows;
